import { Container, Row, Col } from 'react-bootstrap';
import Notification from './Notification';
import { useState } from 'react';

const notificationsDataDefaultVariant = [
  {
    title: 'Designate Beneficiaries',
    description: 'Lorem Ipsum',
    date: 'Due on Aug. 30, 2022',
    isRead: false,
    action: 'Designate',
  },

  {
    title: 'Designate Beneficiaries',
    description: 'Lorem Ipsum',
    date: 'Due on Aug. 30, 2022',
    isRead: false,
  },
];

const notificationsDataPopUpVariant = [
  {
    title: 'Lorem Ipsum',
    description: 'Lorem Ipsum',
    date: 'Due on Aug. 30, 2022',
    isRead: false,
    action: 'Designate',
  },

  {
    title: 'Lorem Ipsum Sit',
    description: 'Lorem Ipsum',
    date: 'Due on Aug. 30, 2022',
    isRead: false,
  },
];

const NotificationDemo = () => {
  const [dataDefault, setIsReadDefault] = useState(
    notificationsDataDefaultVariant
  );
  const [dataPopUp, setIsReadPopUp] = useState(notificationsDataPopUpVariant);

  const handleIsReadDefault = (idx: number) => {
    if (!dataDefault[idx].isRead) {
      const newNotificationObj = [...dataDefault];
      newNotificationObj[idx].isRead = true;

      setIsReadDefault((prev) => (prev = newNotificationObj));
    }
  };

  const handleIsReadPopUp = (idx: number) => {
    if (!dataPopUp[idx].isRead) {
      const newNotificationObj = [...dataPopUp];
      newNotificationObj[idx].isRead = true;

      setIsReadPopUp((prev) => (prev = newNotificationObj));
    }
  };

  return (
    <Container>
      <Row>
        {dataDefault.map((notification, idx) => {
          return (
            <Col key={idx} className={'col-12 mb-7'}>
              <Notification
                notificationData={notification}
                handleAction={() => console.log('Handle Action')}
                onClick={() => handleIsReadDefault(idx)}
              />
            </Col>
          );
        })}
        {dataPopUp.map((notification, idx) => {
          return (
            <Col key={idx} className={'col-6'}>
              <Notification
                notificationData={notification}
                handleAction={() => console.log('Handle Action')}
                onClick={() => handleIsReadPopUp(idx)}
                variant={'pop-up'}
              />
            </Col>
          );
        })}
      </Row>
    </Container>
  );
};

export default NotificationDemo;
